const stats = [
  { num: '300万+', label: '月度吃瓜访客', icon: 'ri-eye-line' },
  { num: '12万+', label: '累计发布内容', icon: 'ri-file-list-3-line' },
  { num: '98%', label: '当日热点覆盖率', icon: 'ri-radar-line' },
  { num: '5年+', label: '专注娱乐资讯', icon: 'ri-calendar-check-line' },
];

const principles = [
  { icon: 'ri-speed-line', t: '快人一步', d: '紧盯全平台动态，热门事件第一时间成稿推送，不错过任何一个窗口期。', c: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-scales-3-line', t: '有底线', d: '涉及个人的内容以公开信息与多方信源为准，未证实的不做定性，代称与待证标注是采编底线。', c: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-shield-check-line', t: '不误导', d: '坚持资讯观察视角而非猎奇渲染，理性吃瓜，让信息回归信息本身的价值。', c: 'bg-secondary-200 text-secondary-800' },
];

const voices = [
  { name: '一只小透明', tag: '通勤刷瓜党', text: '午休刷瓜田已经成了我的固定仪式，更新快、条理清，一个页面就能把今天的瓜全补齐，太省心了。', mark: '★★★★★' },
  { name: '剧集爱好者阿九', tag: '影视线铁粉', text: '最欣赏它家有争议也会标注"待证"，不会为了流量乱扣帽子，作为从业者觉得这份克制很难得。', mark: '★★★★★' },
  { name: '深夜巡逻员', tag: '夜猫子吃瓜', text: '早上漏掉的瓜晚上来盘点区一键补课，页面清爽不花哨，广告也少，体感很好。', mark: '★★★★☆' },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-information-line" aria-hidden="true" /> 关于瓜田网
            </p>
            <h2 className="font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              做一个有温度、有底线的吃瓜阵地
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              瓜田网是一家专注娱乐行业动态与圈内资讯的聚合门户。我们相信，追热点不该变成一场对个人的猎奇与误伤，
              而应该是建立在多方信源与清晰表述之上的信息观察。因此我们坚持：快，但更要有分寸。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-3">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl border border-background-200 bg-background-100/60 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-accent-950">
                    <i className={s.icon} aria-hidden="true" />
                  </span>
                  <p className="font-heading mt-3 text-2xl text-foreground-950">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {principles.map((p) => (
              <div key={p.t} className="flex gap-4 rounded-3xl border border-background-200 bg-background-100/60 p-5">
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl text-xl ${p.c}`}>
                  <i className={p.icon} aria-hidden="true" />
                </span>
                <div>
                  <h3 className="text-[15px] font-semibold text-foreground-950">{p.t}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 用户口碑 */}
        <div className="mt-14">
          <div className="mb-7 text-center">
            <h3 className="font-heading text-2xl text-foreground-950 md:text-3xl">吃瓜群众怎么评价我们</h3>
          </div>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {voices.map((v) => (
              <figure key={v.name} className="flex flex-col rounded-3xl border border-background-200 bg-gradient-to-b from-background-100/80 to-background-50 p-6">
                <span className="text-sm text-secondary-400" aria-label={`${v.name}评分${v.mark}`}>{v.mark}</span>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">“{v.text}”</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 font-heading text-primary-700">
                    {v.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">{v.name}</span>
                    <span className="block text-xs text-foreground-500">{v.tag}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}